import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const vectorSearch: ThemeApp['appComponents']['vectorSearch'] = {
  container: {
    backgroundColor: themeUi.semantic.color.background.secondary950
  },
  featureCard: {
    backgroundColor: themeUi.semantic.color.background.secondary990,
    borderColor: themeUi.semantic.color.border.neutral400,
    boxShadow: themeUi.core.shadow.shadow4
  },
  footerLinks: {
    color: themeUi.semantic.color.text.neutral600
  }
};
